import _, { Dictionary } from "lodash";
import format from "date-fns/format";
import eachDayOfInterval from "date-fns/eachDayOfInterval";
import { differenceInCalendarDays } from "date-fns";

export const Key = (date: Date): string => format(date, "yyyy-MM");

export const Keys = (start: Date, end: Date): string[] => {
  return _.uniq(eachDayOfInterval({ start, end }).map(Key));
};

export class CalendarLike {
  values: Dictionary<string[]> = {};

  get(start: Date, end: Date): string[] {
    const keys = Keys(start, end);
    const duration = differenceInCalendarDays(end, start) + 1;
    if (!this.hasKeys(keys)) {
      return Array(duration).fill("");
    }
    const i = start.getDate() - 1;
    // startベースで日ごとの六曜が得られるはずなので、必要な分だけ取り出す
    const items = this.getDays(keys).slice(i, i + duration);
    if (items.length < duration) {
      // データが足りなかったらダミーデータを返す
      return Array(duration).fill("");
    }
    return items;
  }

  append(key: string, value: string[]): void {
    this.values[key] = value;
  }

  hasKey(key: string): boolean {
    return Boolean(this.values[key]);
  }

  private hasKeys(keys: string[]): boolean {
    return keys.every(this.hasKey.bind(this));
  }

  private getValues(key: string): string[] {
    if (!this.values[key]) return [];
    return this.values[key];
  }

  private getDays(keys: string[]): string[] {
    return _.flatten(keys.map(this.getValues.bind(this)));
  }
}
